import affiliateConfig from "../affiliateConfig";
import merge from "lodash/merge";
import useAppSelector from "./useAppSelector";
import { useMemo } from "react";
export default function useAffiliateConfig() {
    var utmSource = useAppSelector(function (state) { return state.configuration.utmSource; });
    var config = useMemo(function () {
        var config = utmSource
            ? affiliateConfig[utmSource] || affiliateConfig.default
            : affiliateConfig.default;
        return merge(affiliateConfig.default, config);
    }, [utmSource]);
    return config;
}
